module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/95/assets/images/d688e56d1d42ff6090a8fde2ab053e50.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/dropdown-down.svg
// module id = pIOt
// module chunks = 1